import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, SectionLabel, staggerContainer, staggerItem } from "../../lib/motion";
import { BUYER_CONFIDENCE } from "../../data";

export const BuyerConfidence = () => {
  return (
    <section className="py-24 md:py-32 bg-warm-light/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>Buyer Assurance</SectionLabel>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
            Buy With Confidence
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {BUYER_CONFIDENCE.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <motion.div
                key={c.title}
                variants={staggerItem}
                data-testid={`confidence-card-${i}`}
                className="bg-white border border-warm-border rounded-3xl p-7 transition duration-300 hover:-translate-y-1.5 hover:shadow-lg"
              >
                <div className="w-12 h-12 rounded-xl bg-water/10 flex items-center justify-center">
                  <Icon size={22} strokeWidth={1.5} className="text-water" />
                </div>
                <h3 className="mt-5 font-semibold text-navy leading-snug">{c.title}</h3>
                <p className="mt-2 text-warm leading-relaxed text-sm">{c.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
